'use client'
import { useTranslations } from 'next-intl'
import React from 'react'
import styles from './styles.module.scss'

interface PlayForFunProps {
  size?: 'small' | 'normal'
  className?: string
}

const PlayForFunBtn: React.FC<PlayForFunProps> = ({
  className = '',
  ...props
}) => {
  const t = useTranslations('translation')
  return (
    <button
      className={`${styles.button} ${
        props.size === 'small' ? styles.small : styles.normal
      } ${className}`}
      {...props}
    >
      <span>{t('demo')}</span>
    </button>
  )
}

export default PlayForFunBtn
